let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("542YK")).then(() => parcelRequire('6AhPH'));